import { useContext, useEffect, useState, } from "react";

import ListPage from "../../../shared/components/list-page/list-page";
import { IColumn } from "../../../shared/components/normal-table/normal-table";
import Spinner from "../../../shared/components/spinner/spinner";
import AuthContext from "../../../shared/context/auth-context";
import useHttp from "../../../shared/hooks/use-http";
import { getAllData, deleteMultiple, IListPageData } from "../../../shared/utils/api";
import { validateLoadingStatusNew } from "../../../shared/utils/utils";
import { datamodelEntityListUrl } from "../../constants/backend-constants";
import "./tenant-list.scss";

const columns: IColumn[] = [
  {
    key: "name",
    displayName: "Name",
    dataType: {
      type: "text",
    }
  },
];

const TenantList = () => {
  const [data, setData] = useState<IListPageData>({rows: []});
  const [unblockInput, setUnblockInput] = useState(false);
  const [sortedBy, setSortedBy] = useState("?order_by=name asc");
  const [currentOffset, setCurrentOffset] = useState(1);
  const authCtx = useContext(AuthContext);
  const { sendRequest: getSortBy, status: getSortByStatus, data: getSortByData, error: errorGetSortByData } = useHttp(getAllData, true, authCtx.token);
  const { sendRequest: deleteMultipleRequest, status: allStatusDelete, data: loadedDataDelete, error: errorDelete } = useHttp(deleteMultiple, false, authCtx.token);
  const { sendRequest: getSortByPagination, status: getSortByPaginationStatus, data: getSortByPaginationData, error: getSortByPaginationError } = useHttp(getAllData, false, authCtx.token);

  useEffect(() => {
    if (authCtx.systemAdmin) {
      setUnblockInput(true);
    }
  }, [authCtx.selectedTenant, authCtx.systemAdmin]);

  useEffect(() => {
    getSortBy("tenants", "?order_by=name asc&limit=50&offset=0");
  }, [getSortBy]);

  const onTableScrollAction = (offset: number) => {
    if (data && data.rows.length >= 50) {
      setCurrentOffset(offset);
      if (!getSortByPaginationData) {
        getSortByPagination("tenants", `${sortedBy}&limit=50&offset=${offset * 50}`);
      } else if (getSortByPaginationData.rows.length !== 0) {
        getSortByPagination("tenants", `${sortedBy}&limit=50&offset=${offset * 50}`);
      }
    }
  };

  useEffect(() => {
    if (getSortByPaginationStatus === "completed" && !getSortByPaginationError) {
      data && setData({rows: [...data.rows, ...getSortByPaginationData.rows]});
    }
  }, [getSortByPaginationStatus]);

  useEffect(() => {
    if (getSortByStatus === "completed" && !errorGetSortByData) {
      setData(getSortByData);
    }
  }, [getSortByStatus]);

  useEffect(() => {
    if (allStatusDelete === "completed" && !errorDelete) {
      authCtx.userUpdate();
      setData(loadedDataDelete);
    }
  }, [allStatusDelete]);

  const handleOnDelete = (ids: string[]) => {
    deleteMultipleRequest(`tenants${sortedBy}&limit=${currentOffset * 50}&offset=0`, { ids });
  };

  const sortBy = (sortingQuery: string) => {
    getSortBy("tenants", `${sortingQuery}&limit=${currentOffset * 50}&offset=0`);
    setSortedBy(sortingQuery);
  };

  return (
    <div className="tenantList">
      {validateLoadingStatusNew([getSortByStatus, allStatusDelete, getSortByPaginationStatus]) && <Spinner />}
      <ListPage
        title={"Tenants"}
        sortBy={sortBy}
        onTableScrollAction={onTableScrollAction}
        unblockInput={unblockInput}
        defaultSortCol={"name"}
        tooltipTxt={"Overview of all the Groups"}
        columns={columns}
        dataUrl={datamodelEntityListUrl}
        pageMode={"nonEditable"}
        handleOnDelete={handleOnDelete}
        fetchedData={data}
        allStatus={getSortByStatus}
      />
    </div>
  );
};

export default TenantList;
